import "core-js/modules/es6.function.name";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Action, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import Nav from "@/components/nav/navBar.vue";
import fateClass from "@/components/fateClass/fateClass.vue";
import selectBirthday from "@/components/selectBirthday/selectBirthday.vue";
import { i18n } from "@/i18n/i18n-setup";
import BackTrack from "@/utils/backTrack";
import { horoscopeIdex } from "@/utils/horoscopeUtil";
import getHoroscopeFates from "@/utils/getHoroscopeFates";

var ChooseZodiac =
/*#__PURE__*/
function (_Vue) {
  _inherits(ChooseZodiac, _Vue);

  function ChooseZodiac() {
    var _this;

    _classCallCheck(this, ChooseZodiac);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ChooseZodiac).apply(this, arguments));
    _this.comeFrom = "";
    _this.index = -1;
    _this.dataList = [{
      img: _this.$remoteImg("icons/horoscopes/Aries.png"),
      text: i18n.t("common.zodiac.aries"),
      clickFunction: function clickFunction() {
        _this.updateHorscope("Aries");
      }
    }, {
      img: _this.$remoteImg("icons/horoscopes/Taurus.png"),
      text: i18n.t("common.zodiac.taurus"),
      clickFunction: function clickFunction() {
        _this.updateHorscope("Taurus");
      }
    }, {
      img: _this.$remoteImg("icons/horoscopes/Gemini.png"),
      text: i18n.t("common.zodiac.gemini"),
      clickFunction: function clickFunction() {
        _this.updateHorscope("Gemini");
      }
    }, {
      img: _this.$remoteImg("icons/horoscopes/Cancer.png"),
      text: i18n.t("common.zodiac.cancer"),
      clickFunction: function clickFunction() {
        _this.updateHorscope("Cancer");
      }
    }, {
      img: _this.$remoteImg("icons/horoscopes/Leo.png"),
      text: i18n.t("common.zodiac.leo"),
      clickFunction: function clickFunction() {
        _this.updateHorscope("Leo");
      }
    }, {
      img: _this.$remoteImg("icons/horoscopes/Virgo.png"),
      text: i18n.t("common.zodiac.virgo"),
      clickFunction: function clickFunction() {
        _this.updateHorscope("Virgo");
      }
    }, {
      img: _this.$remoteImg("icons/horoscopes/Libra.png"),
      text: i18n.t("common.zodiac.libra"),
      clickFunction: function clickFunction() {
        _this.updateHorscope("Libra");
      }
    }, {
      img: _this.$remoteImg("icons/horoscopes/Scorpio.png"),
      text: i18n.t("common.zodiac.scorpio"),
      clickFunction: function clickFunction() {
        _this.updateHorscope("Scorpio");
      }
    }, {
      img: _this.$remoteImg("icons/horoscopes/Sagittarius.png"),
      text: i18n.t("common.zodiac.sagittarius"),
      clickFunction: function clickFunction() {
        _this.updateHorscope("Sagittarius");
      }
    }, {
      img: _this.$remoteImg("icons/horoscopes/Capricorn.png"),
      text: i18n.t("common.zodiac.capricorn"),
      clickFunction: function clickFunction() {
        _this.updateHorscope("Capricorn");
      }
    }, {
      img: _this.$remoteImg("icons/horoscopes/Aquarius.png"),
      text: i18n.t("common.zodiac.aquarius"),
      clickFunction: function clickFunction() {
        _this.updateHorscope("Aquarius");
      }
    }, {
      img: _this.$remoteImg("icons/horoscopes/Pisces.png"),
      text: i18n.t("common.zodiac.pisces"),
      clickFunction: function clickFunction() {
        _this.updateHorscope("Pisces");
      }
    }];
    _this.isShowSelectDay = false;
    return _this;
  }

  _createClass(ChooseZodiac, [{
    key: "showBirthdayMask",
    value: function showBirthdayMask(value) {
      this.isShowSelectDay = value.isShow;

      if (value.horoScopeName) {
        this.updateHorscope(value.horoScopeName);
        this.index = horoscopeIdex[value.horoScopeName] - 1;
        this.updataLoadingStatus(true);
        getHoroscopeFates.getFates(true);
      }
    }
  }, {
    key: "addedBackTrack",
    value: function addedBackTrack() {
      var _this2 = this;

      //增加安卓返回键：
      BackTrack.listen({
        key: this.$route.name,
        fn: function fn() {
          _this2.clickClose();
        }
      });
    }
  }, {
    key: "removeBackTrack",
    value: function removeBackTrack() {
      BackTrack.destroy(this.$route.name);
    }
  }, {
    key: "clickClose",
    value: function clickClose() {
      this.routerGoBack(-1);
      this.removeBackTrack();
    }
  }, {
    key: "created",
    value: function created() {
      this.comeFrom = this.$route.params.comeFrom;
      this.addedBackTrack();
    }
  }, {
    key: "closeX",
    get: function get() {
      return this.comeFrom === "horoscopeDetails";
    }
  }]);

  return ChooseZodiac;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], ChooseZodiac.prototype, "routerGoBack", void 0);

tslib_1.__decorate([Action(types.ROUTER_REPLACE)], ChooseZodiac.prototype, "routerReplace", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_HOROSCOPE)], ChooseZodiac.prototype, "updateHorscope", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_LOADING_STATUS)], ChooseZodiac.prototype, "updataLoadingStatus", void 0);

ChooseZodiac = tslib_1.__decorate([Component({
  components: {
    Nav: Nav,
    fateClass: fateClass,
    selectBirthday: selectBirthday
  }
})], ChooseZodiac);
export default ChooseZodiac;